import { applyHighlight } from '../procenter/renderProductCard';
var FALLBACK_COVER = 'https://res.daetool.com/wm-static-resource/web/images/help/article-info-img2.png';
function escapeHtml(text) {
    return text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}
function normalizeKeywords(keywords) {
    if (!keywords) {
        return [];
    }
    if (Array.isArray(keywords)) {
        return keywords.map(function (word) { return String(word).trim(); }).filter(Boolean);
    }
    return String(keywords)
        .replace(/，/g, ',')
        .split(',')
        .map(function (word) { return word.trim(); })
        .filter(Boolean);
}
function truncateTagLabel(text, maxLen) {
    if (maxLen === void 0) { maxLen = 16; }
    if (text.length <= maxLen) {
        return text;
    }
    return "".concat(text.slice(0, maxLen), "\u2026");
}
function buildTagSearchUrl(keyword, tab) {
    var rawTab = (tab || 'article').trim() || 'article';
    var resolvedTab = rawTab === 'course' ? 'article' : rawTab;
    return "/searchResult?keywords=".concat(encodeURIComponent(keyword), "&tab=").concat(encodeURIComponent(resolvedTab), "&page=1");
}
function renderTags(keywords, tab) {
    var list = normalizeKeywords(keywords);
    if (!list.length) {
        return '';
    }
    return list
        .map(function (word) {
        var label = truncateTagLabel(word);
        var safe = escapeHtml(label);
        var href = escapeHtml(buildTagSearchUrl(word, tab));
        return "<a class=\"daetool-search-result-article-card__tag\" href=\"".concat(href, "\">").concat(safe, "</a>");
    })
        .join('');
}
function buildArticleUrl(row) {
    var alias = (row.classify_alias || 'article').trim();
    return "/".concat(alias, "/").concat(row.article_id, ".html");
}
export function renderSearchArticleCard(row, highlightKeyword) {
    var articleUrl = escapeHtml(buildArticleUrl(row));
    var cover = escapeHtml((row.page_img || '').trim() || FALLBACK_COVER);
    var title = applyHighlight(row.title || '', highlightKeyword);
    var details = applyHighlight(row.details || '', highlightKeyword);
    var date = escapeHtml(row.create_time || '');
    var tags = renderTags(row.key_word, row.classify_alias);
    return "<article class=\"daetool-search-result-article-card\">\n    <a class=\"daetool-search-result-article-card__cover\" href=\"".concat(articleUrl, "\" target=\"_blank\" rel=\"noopener\">\n      <img src=\"").concat(cover, "\" alt=\"\" onerror=\"this.onerror=null;this.src='").concat(FALLBACK_COVER, "'\">\n    </a>\n    <div class=\"daetool-search-result-article-card__main\">\n      <div class=\"daetool-search-result-article-card__text\">\n        <h3 class=\"daetool-search-result-article-card__title\">\n          <a href=\"").concat(articleUrl, "\" target=\"_blank\" rel=\"noopener\">").concat(title, "</a>\n        </h3>\n        <p class=\"daetool-search-result-article-card__desc\">").concat(details, "</p>\n      </div>\n      <div class=\"daetool-search-result-article-card__footer\">\n        ").concat(tags ? "<div class=\"daetool-search-result-article-card__tags\">".concat(tags, "</div>") : '', "\n        <time class=\"daetool-search-result-article-card__date\">").concat(date, "</time>\n      </div>\n    </div>\n  </article>");
}
export function renderSearchArticleList(items, highlightKeyword) {
    var cards = items
        .map(function (item) { return renderSearchArticleCard(item, highlightKeyword); })
        .join('');
    return "<div class=\"daetool-search-result-article-list\">".concat(cards, "</div>");
}
